<div class="tw-block tw-border-spacing-0 tw-w-full tw-flex-[1] tw-overflow-hidden tw-h-screen tw-font-body">
  @if (isLoading$ | async) {
    <loading id="loading" class="tw-absolute tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"></loading>
  }
  <div class="tw-flex tw-flex-col tw-flex-[1] tw-h-full">
    <div class="tw-w-full tw-flex-initial">
      <div class="tw-bg-black tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-z-[100]">
        <div class="tw-absolute tw-top-2 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10 tw-left-[15px]" (click)="back()">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
        </div>
        @if (!isShiprocketFlow && hasAnyAddress) {
          <span class="tw-text-300 tw-text-white tw-font-lexend tw-font-normal" i18n="@@selectAddress">Delivery address</span>
        }
        @if (isShiprocketFlow && hasAnyAddress) {
          @if ((addressBookList$ | async)?.length === 1) {
            <span class="tw-text-300 tw-text-white tw-font-lexend tw-font-normal" i18n="@@addressFound">{{ (addressBookList$ | async)?.length }} Address Found</span>
          }
          @if ((addressBookList$ | async)?.length > 1) {
            <span class="tw-text-300 tw-text-white tw-font-lexend tw-font-normal" i18n="@@addressesFound">{{ (addressBookList$ | async)?.length }} Addresses Found</span>
          }
        }
      </div>
      @if (isShiprocketFlow && hasAnyAddress && !(isLoading$ | async)) {
        <div id="shiprocketHowBanner"
          class="tw-bg-[#E5F1EE] tw-px-6 tw-py-3">
          <div class="tw-flex tw-items-center tw-justify-between"
            (click)="toggleShiprocketHow()">
            <div class="tw-flex tw-items-center tw-gap-1">
              <span class="tw-font-body tw-text-[10px] tw-leading-5 tw-tracking-[0.1px] tw-text-[#222]" i18n="@@autoFilledBy">Auto-filled by</span>
              <img src="/assets/icons/shiprocket-logo.png"
                class="tw-h-[18px] tw-w-auto tw-mix-blend-multiply"
                alt="Shiprocket" />
            </div>
            <div class="tw-flex tw-items-center tw-gap-1">
              <span class="tw-font-lexend tw-font-bold tw-text-[10px] tw-leading-5 tw-tracking-[0.1px] tw-text-[#0E796C]" i18n="@@shiprocketHowLabel">How?</span>
              <svg class="tw-h-3 tw-w-3 tw-transition-transform"
                [ngClass]="{ 'tw-rotate-180': shiprocketHowExpanded }"
                viewBox="0 0 12 12"
                fill="none">
                <path d="M3 4.5L6 7.5L9 4.5"
                  stroke="#0E796C"
                  stroke-width="1.3"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>
          @if (shiprocketHowExpanded) {
            <p class="tw-font-body tw-text-[10px] tw-leading-[15px] tw-tracking-[0.1px] tw-text-[#616161] tw-mt-2 tw-mb-0" i18n="@@shiprocketHowExplanation">
              With your consent at login, our delivery partner Shiprocket securely shared the addresses from your past orders so you don't have to retype them. Edit or remove any anytime.
            </p>
          }
        </div>
      }
    </div>
    @if (!(isLoading$ | async)) {
      <div class="ld-session-block tw-w-full tw-flex-auto tw-overflow-y-auto tw-overflow-x-hidden tw-bg-gray-100"
           [ngClass]="{
             'tw-pb-[160px]': hasAnyAddress,
             'tw-pb-0': !hasAnyAddress,
             'tw-pt-4': isShiprocketFlow
           }"
        >
        @if (!isShiprocketFlow) {
          @if (!(isLoading$ | async) && !loading) {
            <div id="addAddressRebranded"
              class="tw-flex tw-items-center tw-justify-start tw-gap-2 tw-mb-[14px] tw-text-300 tw-p-5 tw-pt-[16.5px] tw-pb-[18.5px]"
              [class.tw-bg-gray-50]="shouldShowAddressSectionHeaders"
              (click)="addNewAddressClick()"
              >
              <span class="tw-font-lexend tw-font-semibold tw-text-300 tw-text-teal-600 tw-capitalize" i18n="@@addNewAddress">Add new address</span>
              <em class="cs-icon-plus tw-w-4 tw-h-4 tw-text-teal-700"></em>
            </div>
          }
        }
        @if ((defaultAddress$ | async) && !isShiprocketFlow && shouldShowAddressSectionHeaders) {
          <div
            class="tw-pt-0 tw-uppercase tw-font-lexend tw-text-gray-500 tw-text-100 tw-pb-2 tw-pl-6 tw-pr-4"
            i18n="@@defaultAddress"
            >
          Default address
        </div>
        }
        @if (defaultAddress$ | async; as defaultAddress) {
          <div class="tw-mt-0 tw-relative tw-rounded tw-overflow-hidden"
               [ngClass]="{
                 'tw-mx-6 tw-rounded-2 tw-mb-2': isShiprocketFlow,
                 'tw-mx-4 tw-mb-5': !isShiprocketFlow,
                 'tw-bg-white': shouldShowCardHighlight(defaultAddress),
                 'tw-shadow-z13': shouldShowCardHighlight(defaultAddress) && isShiprocketFlow,
                 'tw-shadow-z1': shouldShowCardHighlight(defaultAddress) && !isShiprocketFlow
               }"
            >
            @if (isShiprocketFlow) {
              <div class="tw-py-4 tw-pl-2 tw-font-lexend tw-font-normal" [ngClass]="isShiprocketFlow ? 'tw-pr-4' : 'tw-pr-5'">
                <radio-btn cssClass="tw-shrink-0" contentCssClass="tw-flex tw-flex-col tw-overflow-auto" [checked]="deliverTo?.objectId === defaultAddress.objectId" (checkedChange)="deliverTo = defaultAddress">
                  @if (defaultAddress?.contactName) {
                    <div class="tw-capitalize tw-break-words">
                      {{ defaultAddress?.contactName}},
                    </div>
                  }
                  @if (defaultAddress?.userEmail) {
                    <div class="tw-text-300 tw-break-words">
                      {{ defaultAddress?.userEmail }}
                    </div>
                  }
                  <div id="defaultAddressRebranded" class="tw-text-300 tw-capitalize tw-break-words">
                    {{ getDeliveryAddress(defaultAddress)}}
                  </div>
                  @if (!internalUser) {
                    <div class="tw-text-300 tw-break-words"> +91-{{ defaultAddress.mobileNumber || defaultAddress.alternateNumber }}
                    </div>
                  }
                </radio-btn>
                @if (!isFromReviewOrder || isSelectedAddress(defaultAddress)) {
                  <hr class="tw-ml-[26px] tw-mt-2"/>
                }
                @if (shouldShowDeliveryDate(defaultAddress)) {
                  <div class="tw-ml-[26px] tw-mt-2">
                    <app-expected-delivery-date
                      [expectedDeliveryDate]="deliveryDate"
                      [dayDifference]="deliveryDayDiff"
                      [variant]="DELIVERY_DATE_VARIANT.BADGE"
                      />
                  </div>
                }
                @if (!isFromReviewOrder || isSelectedAddress(defaultAddress)) {
                  <div class="tw-flex tw-w-full tw-ml-[26px]">
                    <span id="defaultAddressEditButtonRebranded" class="tw-text-teal-600 tw-font-semibold tw-text-300 tw-pt-[14px] tw-pb-[6px] tw-px-0" i18n="@@edit" (click)="editAddress(defaultAddress)">Edit</span>
                    <span id="defaultAddressDeleteButtonRebranded" class="tw-text-teal-600 tw-font-semibold tw-text-300 tw-pt-[14px] tw-pb-[6px] tw-px-0 tw-ml-8" i18n="@@delete" (click)="deleteAddress(defaultAddress)">Delete</span>
                  </div>
                }
              </div>
            } @else {
              <div class="tw-py-5 tw-px-4">
                <radio-btn cssClass="tw-shrink-0" contentCssClass="tw-flex tw-flex-col tw-overflow-auto" [checked]="deliverTo?.objectId === defaultAddress.objectId" (checkedChange)="deliverTo = defaultAddress">
                  <div class="tw-capitalize tw-mb-1 tw-text-400 tw-leading-none tw-break-words">{{defaultAddress.tag}}</div>
                  @if (defaultAddress?.contactName) {
                    <div class="tw-capitalize tw-break-words">
                      {{ defaultAddress?.contactName}},
                    </div>
                  }
                  @if (defaultAddress?.userEmail) {
                    <div class="tw-text-300 tw-break-words">
                      {{ defaultAddress?.userEmail }}
                    </div>
                  }
                  <div id="defaultAddress" class="tw-text-300 tw-capitalize tw-break-words">
                    {{ getDeliveryAddress(defaultAddress)}}
                  </div>
                  @if (!internalUser) {
                    <div class="tw-text-300 tw-break-words"> +91-{{ defaultAddress.mobileNumber || defaultAddress.alternateNumber }}
                    </div>
                  }
                </radio-btn>
              </div>
              @if (!isFromReviewOrder || isSelectedAddress(defaultAddress)) {
                <div class="tw-flex tw-w-full tw-bg-gray-100">
                  <span id="defaultAddressEditButton" class="tw-w-1/2 tw-text-center tw-text-200 tw-py-2.5 tw-px-0" i18n="@@edit" (click)="editAddress(defaultAddress)">Edit</span>
                  <span id="defaultAddressDeleteButton" class="tw-w-1/2 tw-text-center tw-text-200 tw-py-2.5 tw-px-0 tw-border-l tw-border-l-white" i18n="@@delete" (click)="deleteAddress(defaultAddress)">Delete</span>
                </div>
              }
            }
          </div>
        }
        @if ((otherAddressList$ | async)?.length && !isShiprocketFlow && shouldShowAddressSectionHeaders) {
          <div
            class="tw-uppercase tw-font-lexend tw-text-gray-500 tw-text-100 tw-leading-[21px] tw-pl-6 tw-pr-4 tw-pb-2"
            i18n="@@otherAddress"
          > Other addresses </div>
        }
        @if (isShiprocketFlow) {
          @for (address of (otherAddressList$ | async); track address; let i = $index) {
            <div class="tw-mt-0 tw-mx-6 tw-relative tw-rounded-2 tw-font-lexend tw-font-normal tw-overflow-hidden"
               [ngClass]="{
                 'tw-mb-2': isShiprocketFlow,
                 'tw-mb-5': !isShiprocketFlow,
                 'tw-bg-white': shouldShowCardHighlight(address),
                 'tw-shadow-z13': shouldShowCardHighlight(address) && isShiprocketFlow,
                 'tw-shadow-z1': shouldShowCardHighlight(address) && !isShiprocketFlow
               }"
              >
              <div class="tw-pl-2 tw-py-4" [ngClass]="isShiprocketFlow ? 'tw-pr-4' : 'tw-pr-5'">
                <radio-btn cssClass="tw-shrink-0" contentCssClass="tw-flex tw-flex-col tw-overflow-auto" [checked]="deliverTo?.objectId === address.objectId" (checkedChange)="deliverTo = address">
                  <div class="tw-capitalize tw-break-words">{{ address?.contactName }},</div>
                  @if (address?.userEmail) {
                    <div class="tw-text-300 tw-break-words">
                      {{ address?.userEmail }}
                    </div>
                  }
                  <div id="deliveryAddressRebranded" class="tw-text-300 tw-break-words">
                    {{ address.buildingDetails}}, {{ address.localityDetails}}, {{ address.landmark}}
                  </div>
                  <div class="tw-text-300 tw-break-words">
                    {{ address.city}}, {{ address.state}} - {{ address.zipCode}}
                  </div>
                  @if (!internalUser) {
                    <div class="tw-text-300 tw-break-words"> +91-{{ address.mobileNumber || address.alternateNumber }}
                    </div>
                  }
                </radio-btn>
                @if (isSelectedAddress(address)) {
                  <hr class="tw-ml-[26px] tw-mt-2"/>
                }
                @if (shouldShowDeliveryDate(address)) {
                  <div class="tw-ml-[26px] tw-mt-2">
                    <app-expected-delivery-date
                      [expectedDeliveryDate]="deliveryDate"
                      [dayDifference]="deliveryDayDiff"
                      [variant]="DELIVERY_DATE_VARIANT.BADGE"
                      />
                  </div>
                }
                @if (isSelectedAddress(address)) {
                  <div class="tw-flex tw-w-full tw-ml-[26px]">
                    <span id="editButtonRebranded" class="tw-text-teal-600 tw-font-semibold tw-text-300 tw-pt-[14px] tw-pb-[6px] tw-px-0" i18n="@@edit" (click)="editAddress(address, i)">Edit</span>
                    <span id="deleteButtonRebranded" class="tw-text-teal-600 tw-font-semibold tw-text-300 tw-pt-[14px] tw-pb-[6px] tw-px-0 tw-ml-8" i18n="@@delete" (click)="deleteAddress(address)">Delete</span>
                  </div>
                }
              </div>
            </div>
          }
        } @else {
          @for (address of otherAddressList$ | async; track address) {
            <div class="tw-mt-0 tw-mx-4 tw-mb-5 tw-relative tw-rounded tw-overflow-hidden tw-bg-white tw-shadow-z1">
              <div class="tw-py-5 tw-px-4">
                <radio-btn cssClass="tw-shrink-0" contentCssClass="tw-flex tw-flex-col tw-overflow-auto" [checked]="deliverTo?.objectId === address.objectId" (checkedChange)="deliverTo = address">
                  <div class="tw-capitalize tw-mb-1 tw-text-400 tw-leading-none tw-break-words">{{address.tag}}</div>
                  <div class="tw-capitalize tw-break-words">{{ address?.contactName }},</div>
                  @if (address?.userEmail) {
                    <div class="tw-text-300 tw-break-words">
                      {{ address?.userEmail }}
                    </div>
                  }
                  <div id="deliveryAddress" class="tw-text-300 tw-break-words">
                    {{ address.buildingDetails}}, {{ address.localityDetails}}, {{ address.landmark}}
                  </div>
                  <div class="tw-text-300 tw-break-words">
                    {{ address.city}}, {{ address.state}} - {{ address.zipCode}}
                  </div>
                  @if (!internalUser) {
                    <div class="tw-text-300 tw-break-words"> +91-{{ address.mobileNumber || address.alternateNumber }}
                    </div>
                  }
                </radio-btn>
              </div>
              @if (deliverTo?.objectId === address.objectId) {
                <div class="tw-flex tw-w-full tw-bg-gray-100">
                  <span id="editButton" class="tw-w-1/2 tw-text-center tw-text-200 tw-py-2.5 tw-px-0" i18n="@@edit" (click)="editAddress(address)">Edit</span>
                  <span id="deleteButton" class="tw-w-1/2 tw-text-center tw-text-200 tw-py-2.5 tw-px-0 tw-border-l tw-border-l-white" i18n="@@delete" (click)="deleteAddress(address)">Delete</span>
                </div>
              }
            </div>
          }
        }
      </div>
      @if (isShiprocketFlow && !hasAnyAddress && !loading) {
        <div class="tw-h-full tw-w-full tw-flex tw-justify-center tw-pt-28 tw-px-11 tw-bg-gray-100">
          <div class="tw-flex tw-flex-col tw-gap-4 tw-w-[273px]">
            <div>
              <img src="/assets/icons/no-location-icon.svg" class="tw-w-[86px] tw-aspect-square tw-mx-auto tw-mix-blend-multiply" alt="Powered By Shiprocket" />
            </div>
            <div class="tw-font-lexend tw-font-normal tw-text-center">
              <p class="tw-font-[700] tw-text-600 tw-px-6 tw-mb-2" i18n="@@unableToFetchSavedAddress">Sorry! We are not able to fetch any saved address</p>
              <p class="tw-text-gray-800 tw-text-300">
                <span i18n="@@numberLabel">Number:</span>
                <span> +91 {{ shiprocketPhone }}</span>
              </p>
            </div>
            <div>
              <div
                type="button"
                class="tw-w-full tw-rounded-3 tw-py-3 tw-text-500 tw-font-[600] tw-text-white tw-font-lexend tw-mx-0 tw-text-center tw-bg-teal-600 tw-mb-2"
                (click)="tryWithAnotherNumber()"
                i18n="@@tryWithAnotherNumber"
                >
              Try with another number
            </div>
              <div
                type="button"
                class="tw-w-full tw-rounded-3 tw-py-[11px] tw-text-500 tw-font-[600] tw-text-teal-600 tw-font-lexend tw-mx-0 tw-text-center tw-border-[1.3px] tw-border-teal-600"
                (click)="addAddressManually()"
                i18n="@@addAddressManually"
                >
              Add address manually
            </div>
            </div>
          </div>
        </div>
      }
      <!-- Rebranded Continue CTA -->
      @if (shouldShowRebrandedContinue) {
        <div class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-flex-none" [ngClass]="isShiprocketFlow ? 'tw-bg-gray-100 tw-px-6 tw-py-5' : 'tw-p-5 bg-white'">
          <button csButton
            id="continueButtonRebranded"
            type="button"
            class="tw-w-full"
            [loading]="inProcess || (checkoutInProgress$ | async)"
            [disabled]="!deliverTo?.objectId"
            (click)="isShiprocketFlow ? continueFromShiprocketFlow() : saveAsDeliveryAddress()">
            @if (isShiprocketFlow) {
              <span i18n="@@selectShiprocketAddress">Select Address</span>
            } @else {
              <span i18n="@@useThisAddress">Use this address</span>
            }
          </button>
          @if (isShiprocketFlow) {
            <div id="addNewAddressBottom"
              class="tw-h-12 tw-flex tw-items-center tw-justify-center tw-gap-2"
              (click)="addNewAddressClick()">
              <span class="tw-font-lexend tw-font-semibold tw-text-400 tw-text-teal-600 tw-capitalize" i18n="@@addNewAddress">Add new address</span>
              <em class="cs-icon-plus tw-text-400 tw-leading-none tw-text-teal-600"></em>
            </div>
          }
        </div>
      }
      <!-- Existing Continue CTA -->
      @if (shouldShowExistingContinue) {
        <div class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-flex-none tw-p-5 bg-white">
          <button csButton
            id="continueButton"
            type="button"
            class="tw-w-full"
            [loading]="inProcess || (checkoutInProgress$ | async)"
            [disabled]="!deliverTo?.objectId"
            (click)="isShiprocketFlow ? continueFromShiprocketFlow() : saveAsDeliveryAddress()">
            <span i18n="@@useThisAddress">Use this address</span>
          </button>
        </div>
      }
    }
  </div>
</div>
